import React from 'react'

import { DepthKeys, useLanguages } from '@/hooks'
import { INavItem } from '@/types'
import { Link } from '@/i18n'

export const Item: React.FC<INavItem<DepthKeys> & { path: string }> = ({
  path,
  title,
}) => {
  const { t } = useLanguages()
  return (
    <li>
      <Link href={path}>{t(title)}</Link>
    </li>
  )
}
